import React from 'react';
import { Code, FileCode, Database, Server } from 'lucide-react';

/**
 * Компонент боковой панели с примерами использования Bcrypt
 */
const UsageSidebar = () => {
  const examples = [
    {
      title: 'Node.js',
      language: 'javascript',
      code: `const bcrypt = require('bcrypt');

// Хеширование пароля
const hash = await bcrypt.hash(password, 10);

// Проверка пароля
const isMatch = await bcrypt.compare(
  password, hash
);`
    },
    {
      title: 'PHP',
      language: 'php',
      code: `<?php
// Хеширование пароля
$hash = password_hash($password, 
  PASSWORD_BCRYPT, ['cost' => 10]);

// Проверка пароля
if (password_verify($password, $hash)) {
  // Правильный пароль
}
?>`
    },
    {
      title: 'Python',
      language: 'python',
      code: `import bcrypt

# Хеширование пароля
hashed = bcrypt.hashpw(
  password.encode(), bcrypt.gensalt())

# Проверка пароля
if bcrypt.checkpw(password.encode(), hashed):
  # Правильный пароль`
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Code className="w-5 h-5 mr-2 text-blue-500" />
        Примеры использования
      </h3>

      <div className="space-y-4">
        {examples.map((example, index) => (
          <div key={index} className="rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
            <div className="bg-gray-50 dark:bg-gray-700 p-2 flex items-center">
              <FileCode className="w-4 h-4 mr-2 text-blue-500" />
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                {example.title}
              </span>
            </div>
            <div className="p-3 bg-gray-100 dark:bg-gray-800 overflow-x-auto">
              <pre className="text-xs text-gray-800 dark:text-gray-200 font-mono">
                {example.code}
              </pre>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-6 space-y-4">
        <div className="flex items-start p-3 rounded-lg bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700">
          <Database className="w-5 h-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
              Хранение в базе данных
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Используйте поле VARCHAR(60) для хранения Bcrypt-хешей в базах данных. Размер стандартного хеша Bcrypt составляет 60 символов.
            </p>
          </div>
        </div>
        
        <div className="flex items-start p-3 rounded-lg bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700">
          <Server className="w-5 h-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
              Интеграция в российских системах
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Bcrypt совместим с большинством фреймворков и CMS, распространенных в России, включая 1С-Битрикс, Laravel, Symfony и Django. Большинство функций авторизации в этих системах уже используют Bcrypt для хранения паролей.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsageSidebar;